export const travelTypes = ['insurance', 'transfer', 'transferCruise', 'handling', 'railAndFly', 'excursion'];
